/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_SubscribedInputs */

const en_status_subscribed = /** @type {(inputs: Status_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`subscribed`)
};

const id_status_subscribed = /** @type {(inputs: Status_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`berlangganan`)
};

const ms_status_subscribed = /** @type {(inputs: Status_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dilanggan`)
};

const ca_status_subscribed = /** @type {(inputs: Status_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`subscrit`)
};

const cs_status_subscribed = /** @type {(inputs: Status_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`odebíráno`)
};

const da_status_subscribed = /** @type {(inputs: Status_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tilmeldt`)
};

const de_status_subscribed = /** @type {(inputs: Status_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonniert`)
};

const et_status_subscribed = /** @type {(inputs: Status_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tellitud`)
};

const es_status_subscribed = /** @type {(inputs: Status_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`suscrito`)
};

const fr_status_subscribed = /** @type {(inputs: Status_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`payé`)
};

const hr_status_subscribed = /** @type {(inputs: Status_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aktivno`)
};

const it_status_subscribed = /** @type {(inputs: Status_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abbonato`)
};

const lv_status_subscribed = /** @type {(inputs: Status_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`abonēts`)
};

const lt_status_subscribed = /** @type {(inputs: Status_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`prenumeruojama`)
};

const hu_status_subscribed = /** @type {(inputs: Status_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`feliratkozott`)
};

const nl_status_subscribed = /** @type {(inputs: Status_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`geabonneerd`)
};

const nb_status_subscribed = /** @type {(inputs: Status_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`abonnert`)
};

const pl_status_subscribed = /** @type {(inputs: Status_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`zasubksrybowano`)
};

const pt_status_subscribed = /** @type {(inputs: Status_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`inscrito`)
};

const ro_status_subscribed = /** @type {(inputs: Status_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`abonat`)
};

const sk_status_subscribed = /** @type {(inputs: Status_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`predplatené`)
};

const sl_status_subscribed = /** @type {(inputs: Status_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aktivna naročnina`)
};

const fi_status_subscribed = /** @type {(inputs: Status_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tilattu`)
};

const sv_status_subscribed = /** @type {(inputs: Status_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`prenumererade`)
};

const vi_status_subscribed = /** @type {(inputs: Status_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`đã đăng ký`)
};

const tr_status_subscribed = /** @type {(inputs: Status_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`abone olundu`)
};

const el_status_subscribed = /** @type {(inputs: Status_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`εγγραφήκατε`)
};

const bg_status_subscribed = /** @type {(inputs: Status_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`абонирани`)
};

const ru_status_subscribed = /** @type {(inputs: Status_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`подписано`)
};

const sr_status_subscribed = /** @type {(inputs: Status_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`активно`)
};

const uk_status_subscribed = /** @type {(inputs: Status_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ви підписані`)
};

const ka_status_subscribed = /** @type {(inputs: Status_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`გამოწერილი`)
};

const hi_status_subscribed = /** @type {(inputs: Status_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सब्सक्राइब्ड `)
};

const th_status_subscribed = /** @type {(inputs: Status_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เป็นสมาชิก`)
};

const ko_status_subscribed = /** @type {(inputs: Status_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구독 중`)
};

const zh_status_subscribed = /** @type {(inputs: Status_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已订阅`)
};

const zh_tw_status_subscribed = /** @type {(inputs: Status_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已訂閱`)
};

const ja_status_subscribed = /** @type {(inputs: Status_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`購入済み`)
};

/**
* | output |
* | --- |
* | "subscribed" |
*
* @param {Status_SubscribedInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const status_subscribed = /** @type {((inputs?: Status_SubscribedInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_SubscribedInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_status_subscribed(inputs)
	if (locale === "ms") return ms_status_subscribed(inputs)
	if (locale === "ca") return ca_status_subscribed(inputs)
	if (locale === "cs") return cs_status_subscribed(inputs)
	if (locale === "da") return da_status_subscribed(inputs)
	if (locale === "de") return de_status_subscribed(inputs)
	if (locale === "et") return et_status_subscribed(inputs)
	if (locale === "es") return es_status_subscribed(inputs)
	if (locale === "fr") return fr_status_subscribed(inputs)
	if (locale === "hr") return hr_status_subscribed(inputs)
	if (locale === "it") return it_status_subscribed(inputs)
	if (locale === "lv") return lv_status_subscribed(inputs)
	if (locale === "lt") return lt_status_subscribed(inputs)
	if (locale === "hu") return hu_status_subscribed(inputs)
	if (locale === "nl") return nl_status_subscribed(inputs)
	if (locale === "nb") return nb_status_subscribed(inputs)
	if (locale === "pl") return pl_status_subscribed(inputs)
	if (locale === "pt") return pt_status_subscribed(inputs)
	if (locale === "ro") return ro_status_subscribed(inputs)
	if (locale === "sk") return sk_status_subscribed(inputs)
	if (locale === "sl") return sl_status_subscribed(inputs)
	if (locale === "fi") return fi_status_subscribed(inputs)
	if (locale === "sv") return sv_status_subscribed(inputs)
	if (locale === "vi") return vi_status_subscribed(inputs)
	if (locale === "tr") return tr_status_subscribed(inputs)
	if (locale === "el") return el_status_subscribed(inputs)
	if (locale === "bg") return bg_status_subscribed(inputs)
	if (locale === "ru") return ru_status_subscribed(inputs)
	if (locale === "sr") return sr_status_subscribed(inputs)
	if (locale === "uk") return uk_status_subscribed(inputs)
	if (locale === "ka") return ka_status_subscribed(inputs)
	if (locale === "hi") return hi_status_subscribed(inputs)
	if (locale === "th") return th_status_subscribed(inputs)
	if (locale === "ko") return ko_status_subscribed(inputs)
	if (locale === "zh") return zh_status_subscribed(inputs)
	if (locale === "zh-tw") return zh_tw_status_subscribed(inputs)
	if (locale === "ja") return ja_status_subscribed(inputs)
	return en_status_subscribed(inputs)
});